import { addQuotes, addQuotesInBlank } from '../utils/smartutils';
import { AVAILABLE_TO, COMMUNICATION_CHANNEL_TYPE } from '../utils/constants';

export function comChannelListByFilter(filter) {
  const query = `{comChannelListByFilter(filter: ${JSON.stringify(
    filter
  ).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}){ id, name, description, type,  availableTo, active, fileUrl, unreadMessageQuantity, userChat{id} }}`;

  return query;
}

export function relationObjectListByParams() {
  const query = `{relationObjectListByParams(showResponsible:true, showResponsibleType:true, showAll:true, showResponsibleKindWithStudent: true, type:"R", showStudents:true, showSchoolClasses:true)
{id, description, type}
}`;

  return query;
}

export function availableEmployeeComChannel() {
  const query = `{availableEmployeeComChannel(id:0)
{id, name}
}`;
  return query;
}

export function comChannelListById(id) {
  const query = `{comChannelListByFilter(filter: {id:${id}}) 
{ id, name, description, type,  availableTo,  active, fileUrl, unreadMessageQuantity, co90File, visibleTo{id, description, type}, employees{id, name}, availablEmployees{id, name},  userChat{id}  }}`;

  return query;
}

export function comChannelDeleteNoUnreadMessages(values) {
  const mutationQuery = `mutation{
	comChannelDelete(
            communicationChanel:{
                id: ${values.id},
                name: "${values.name}",
                description: "${values.description ? values.description : ''}",
                type: "${values.type}",
                availableTo: "${values.availableTo}",
                active: ${values.active},
				userChat: ${JSON.stringify(values.userChat).replace(/"([^(")"]+)":/g, '$1:')},
                unreadMessageQuantity: ${values.unreadMessageQuantity},
            },
			communicationChanelToReplace:{unreadMessageQuantity:0,
                                          active: false,
                                          id:0}
                       
  )
}`;
  return mutationQuery;
}

export function comChannelDeleteUnreadMessages(
  selectedItem,
  communicationChanelToReplace
) {
  const mutationQuery = `mutation{
	comChannelDelete(
            communicationChanel:{
                id: ${selectedItem.id},
                name: "${selectedItem.name}",
                description: "${selectedItem.description}",
                type: "${selectedItem.type}",
                availableTo: "${selectedItem.availableTo}",
                active: false,
				userChat:${JSON.stringify(selectedItem.userChat).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
				unreadMessageQuantity: ${selectedItem.unreadMessageQuantity},
            },
			communicationChanelToReplace:{
                id: ${communicationChanelToReplace.id},
                name: "${communicationChanelToReplace.name}",
                description: "${communicationChanelToReplace.description}",
                type: "${communicationChanelToReplace.type}",
                availableTo: "${communicationChanelToReplace.availableTo}",
                active: false,
				userChat: ${JSON.stringify(communicationChanelToReplace.userChat).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
				unreadMessageQuantity: ${communicationChanelToReplace.unreadMessageQuantity},
            }
	)
}`;
  return mutationQuery;
}

export function comChannelSave(values) {
  const mappedVisibleTo = values.visibleTo.map((item) => ({
    id: item.id,
    description: item.description,
    type: item.type,
    quantity: 0,
  }));

  const mappedEmployees = values.employees.map((item) => ({
    id: item.id,
    name: item.label,
    filterByStatus: false,
    updaterId: 0,
    usuarioChatInterno: false,
    ativo: false,
    pedagogicAdm: false,
    active: false,
    usuarioChat: false,
  }));

  const mutationQuery = `mutation
{
        comChannelSave(communicationChanel:{
        id: ${values.id},
        name: ${addQuotes(values.name)},
        description: ${
          values.description
            ? addQuotes(values.description)
            : addQuotesInBlank()
        },
        type: ${
          values.type
            ? addQuotes(values.type)
            : addQuotes(COMMUNICATION_CHANNEL_TYPE.EXTERNAL)
        },
        availableTo: ${
          values.availableTo
            ? addQuotes(values.availableTo)
            : addQuotes(AVAILABLE_TO.ONLY_RESPONSIBLES)
        },
        active: false,
        fileUrl: ${
          values.fileUrl ? addQuotes(values.fileUrl) : addQuotesInBlank()
        },
        co90File: ${
          values.co90File ? addQuotes(values.co90File) : addQuotesInBlank()
        },
        unreadMessageQuantity: ${
          values.unreadMessageQuantity ? values.unreadMessageQuantity : 0
        },
        visibleTo: ${JSON.stringify(mappedVisibleTo).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},
        employees: ${JSON.stringify(mappedEmployees).replace(
          /"([^(")"]+)":/g,
          '$1:'
        )},}),
        {id}
}`;
  return mutationQuery;
}
